import User from "../../Users/Domain/User";

class Admin {
  static get ADMIN_ROLES() {
    return [
      User.ADMIN,
      User.EGREEN,
      User.PROJECTS_VIEWER,
      User.CARBON_MANAGEMENT,
      User.CARBON_CREDITS,
      User.AUDITOR,
      User.SUSTAINABILITY,
    ];
  }

  constructor({
    id,
    _id,
    name,
    email,
    verified,
    enabled,
    publicKey,
    withdrew_usd,
    access_level,
    profile_picture,
  }) {
    this.id = id || _id;
    this.name = name;
    this.username = name;
    this.email = email;
    this.verified = verified;
    this.enabled = enabled;
    this.publicKey = publicKey;
    this.withdrew_usd = withdrew_usd;
    this.access_level = access_level;
    this.profile_picture = profile_picture;
  }

  get verifiedValue() {
    switch (this.verified) {
      case "starter":
        return "No iniciado";
      case "pending":
        return "Pendiente";
      case "rejected":
        return "Rechazado";
      case "succeeded":
        return "Verificado";
      case "data_loaded":
        return "Información inicial cargada";
      default:
        return "No iniciado";
    }
  }

  get enabledValue() {
    return this.enabled ? "Activado" : "Desactivado";
  }

  get usernameForSearcher() {
    return `${this.email} (${this.name} | ${this.access_level})`;
  }

  get userName() {
    return this.name;
  }
}

export default Admin;
